export { default } from "./TimelineSeparator.js";
export { default as timelineSeparatorClasses } from "./timelineSeparatorClasses.js";
export * from "./timelineSeparatorClasses.js";